import { cva, type VariantProps } from 'class-variance-authority';
import React from 'react';

import { cn } from '../../../shadcn/lib/utils';

const indicatorVariants = cva(
  'inline-flex items-center justify-center w-6 h-6 text-xs rounded-full mr-1 cursor-pointer select-none',
  {
    variants: {
      appearance: {
        aquamarine: 'bg-[var(--color-aquamarine-500)] text-typography',
        dodger: 'bg-[var(--color-dodger-500)] text-typography',
        mauve: 'bg-[var(--color-mauve-500)] text-typography',
        pink: 'bg-[var(--color-pink-500)] text-typography',
        primary: 'bg-primary-700 text-white',
        secondary: 'bg-secondary-200 text-typography',
      },
    },
    defaultVariants: {
      appearance: 'primary',
    },
  }
);

interface IndicatorProps extends VariantProps<typeof indicatorVariants> {
  readonly children?: React.ReactNode;
  readonly className?: string;
}

export function Indicator({ children, appearance, className, ...props }: IndicatorProps) {
  const variantsClassName = indicatorVariants({ appearance });
  return (
    <span className={cn(variantsClassName, className)} {...props}>
      {children}
    </span>
  );
}
